var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82058 16.0531C3.55001 16.0531 0.0840454 12.5873 0.0840454 8.31661C0.0840454 4.04597 3.54994 0.580078 7.82058 0.580078C12.0912 0.580078 15.5571 4.04597 15.5571 8.31661C15.5571 12.5873 12.0912 16.0531 7.82058 16.0531ZM7.82058 1.59099C4.10704 1.59099 1.09495 4.603 1.09495 8.31661C1.09495 12.0302 4.10697 15.0422 7.82058 15.0422C11.5342 15.0422 14.5462 12.0302 14.5462 8.31661C14.5462 4.603 11.5342 1.59099 7.82058 1.59099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82061 4.00479C6.232 4.00479 4.93237 5.30456 4.93237 6.89302C4.93237 8.72916 7.82061 12.649 7.82061 12.649C7.82061 12.649 10.7088 8.72916 10.7088 6.89302C10.7088 5.30427 9.40921 4.00464 7.82061 4.00464V4.00479ZM6.83037 7.88337C5.71638 6.43925 7.36673 4.78875 8.81099 5.90274C9.92498 7.34701 8.27452 8.97691 6.83037 7.88337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f53bd89e28b058103b2293ba2152af4a.svg";
export { ForwardRef as ReactComponent };